import { useIntl } from 'react-intl';
import { CmdModal, CmdModalFooterButton } from '@commander-services/gui-components';
import TripPositions from '../../TripPositions';
import { ITripsOverViewRecord } from '../interfaces';

interface ITripDetailProps {
  closeCallback: () => void;
  data: ITripsOverViewRecord;
}

export default function TripDetail(props: ITripDetailProps): JSX.Element {
  const { formatMessage: f } = useIntl();

  const buttons: CmdModalFooterButton[] = [
    {
      id: 'close-modal',
      type: 'button',
      className: 'e-button',
      title: f({ id: 'alarms.modal.rule.button.close' }),
      tooltip: f({ id: 'rides.modal.close.tooltip' }),
      closeCallback: props.closeCallback,
    },
  ];

  return (
    <CmdModal
      id="ride-detail-modal"
      title={`${f({ id: 'tables.tripsOverview.actions.ridePosition.modal' })}`}
      footerButtons={buttons}
      width="1100px"
    >
      {props.data && props.data.id && props.data.vehicle?.id && (
        <TripPositions
          vehicleId={props.data.vehicle.id}
          id={props.data.id}
          vehicleName={`${props.data.vehicle.licenceNumber} - ${props.data.vehicle.name}`}
          startAddress={props.data.address.start}
          endAddress={props.data.address.end}
        />
      )}
    </CmdModal>
  );
}
